import { User, W9FormData } from '@bybeam/platform-types';
import Link from '@platform-ui-common/components/Link/index.js';
import TextInput from '@platform-ui-common/components/TextInput/index.js';
import Typography from '@platform-ui-common/components/Typography/index.js';
import { fieldUpdate } from '@platform-ui-common/hooks/useForm/index.js';
import { FormProps } from '@platform-ui-common/types/index.js';
import Panel from './Panel.js';

const Certification = ({
  formData,
  dispatch,
  errors,
  user,
}: FormProps<W9FormData> & { user: User }): JSX.Element => {
  return (
    <Panel>
      <Typography variant="body">Certification</Typography>
      <Typography variant="body">Under penalties of perjury, I certify that:</Typography>
      <Typography variant="body">
        1. The number shown on this form is my correct taxpayer identification number (or I am
        waiting for a number to be issued to me); and
      </Typography>
      <Typography variant="body">
        2. I am not subject to backup withholding because: (a) I am exempt from backup withholding,
        or (b) I have not been notified by the Internal Revenue Service (IRS) that I am subject to
        backup withholding as a result of a failure to report all interest or dividends, or (c) the
        IRS has notified me that I am no longer subject to backup withholding; and
      </Typography>
      <Typography variant="body">
        3. I am a U.S. citizen or other U.S. person as defined in{' '}
        <Link external target="_blank" bold={false} to="https://www.irs.gov/pub/irs-pdf/fw9.pdf">
          Form W-9
        </Link>
        ; and
      </Typography>
      <Typography variant="body">
        4. The FATCA code(s) entered on this form (if any) indicating that I am exempt from FATCA
        reporting is correct.
      </Typography>
      <TextInput
        id="signature"
        label="Electronic Signature"
        required
        value={formData.signature ?? ''}
        onChange={(value: string): void => dispatch(fieldUpdate('signature', value))}
        error={errors.signature as string}
        helperText={`(${user.name})`}
        type="signature"
      />
    </Panel>
  );
};

export default Certification;
